/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Actions from './Actions/index'
import CloseAction from './CloseAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import NoteTextArea from 'DesignSystem/NoteTextArea/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/FutureSeparator/Actions/NewNote/Write/Content",
  onChange,
  isSubmitting
  
}) {
let editorNoteValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'note',
})
let editorNoteChangeData = fromData.useDataChange({ viewPath,
context: 'editor',
path: 'note',
})
let editorNoteIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'editor',
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={0}
 level="h2"
 text="Treatment comment"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<NoteTextArea
  viewPath={`${viewPath}/NoteTextArea`}
 data="editor.note"
 value={editorNoteValueData}
 onChange={editorNoteChangeData}
 disabled={editorNoteIsSubmittingData}
 templateTags="appointment"
 plaintext={false}
 menubar={false}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}